/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Delivery_DmsInputs */



/**
* | output |
* | --- |
* | "+ Admin DMs" |
*
* @param {Pricing_Delivery_DmsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_delivery_dms = /** @type {((inputs?: Pricing_Delivery_DmsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Delivery_DmsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("+ ЛС администраторам")
	return /** @type {LocalizedString} */ ("+ Admin DMs")
});